import axios from 'lib/axios'

export type AdminCapabilityAssignment = {
  admin_id: string
  capability_id: string
}

export const updateAdminCapabilities = async (changes: {
  assignments?: AdminCapabilityAssignment[]
  removals?: AdminCapabilityAssignment[]
  replacements?: Array<{ admin_id: string; capability_ids: string[] }>
}): Promise<void> => {
  await axios.put('/admin/admin_capabilities', {
    assignments: changes.assignments ?? [],
    removals: changes.removals ?? [],
    replacements: changes.replacements ?? []
  })
}
